module.exports = __webpack_public_path__ + "static/img/theatre_3.9a3db9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/theatre_3.jpg
// module id = HAQE
// module chunks = 3